export default __webpack_public_path__ + "static/media/Screenshot (8).be38207a.png";